import { render, staticRenderFns } from "./MarketSegmentRadioField.vue?vue&type=template&id=471d110f"
import script from "./MarketSegmentRadioField.vue?vue&type=script&lang=js"
export * from "./MarketSegmentRadioField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports